import styled from "styled-components"

import {InfoWindow} from "@irati-web/geolocation/src/components/GeoMap"
import IconText from "@irati/ui/src/IconText"
import {H3} from "@irati/ui/src/Typography/Heading"
import Icon from "@irati/ui/src/Icon"
import {minWidthMedia} from "@irati/ui/src/global/media"

export const StyledDefaultInfoWindow = styled(InfoWindow)`
  min-width: 150px;

  ${minWidthMedia.tablet`
    min-width: 300px;
  `}
`

export const StyledH3 = styled(H3)`
  ${minWidthMedia.tablet`
    font-size: 18px;
    line-height: 21px;
  `}
`
export const StyledIconText = styled(IconText)`
  white-space: nowrap;

  ${Icon}{
    vertical-align: baseline !important;
    margin-right: 0;
  }
`
